export const apiRoutes = {
  endpoints: {
    // ── Reports Engine ─────────────────────────────────────────────────────

    // Template registry
    engineTemplates: 'reports/engine/templates',

    // Generated report artifacts
    engineReports: 'reports/engine/reports',
    engineReportById: 'reports/engine/reports/${reportId}',
    engineReportHtml: 'reports/engine/reports/${reportId}/html',
    engineReportDownload: 'reports/engine/reports/${reportId}/download',

    // One-off report generation (queued via scheduler)
    engineGenerateReport: 'reports/engine/${reportType}/generate',

    // Recent settled batches for the active profile — drives the BSR batch picker
    settledBatches: 'batches/settled',

    // Recurring schedule definitions
    engineSchedules: 'reports/engine/schedules',
    engineScheduleById: 'reports/engine/schedules/${defnId}',
    engineScheduleRun: 'reports/engine/schedules/${defnId}/run',
    engineSchedulePause: 'reports/engine/schedules/${defnId}/pause',
    engineScheduleResume: 'reports/engine/schedules/${defnId}/resume',
  },
};
